<template>
  <div id="sideBarMenu">
    <div id="logoPanel">
      <router-link target="_blank" id="gotoHome" class="d-flex justify-content-center" to="/">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="70"
          height="70"
          viewBox="0 0 674 789"
          enable-background="new 0 0 674 789"
          xml:space="preserve"
        >
          <image
            id="image0"
            width="674"
            height="789"
            x="0"
            y="0"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAqIAAAMVCAYAAACsuZaKAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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"
          />
        </svg>
      </router-link>
    </div>
    <!-- <p style="text-align: center; padding: 10px;; border-bottom: 2px solid #eb5e1a; background-color: rgb(189, 187, 187);" 
    v-if="showRoute(getRole, '/admin-panel/calibrationLab/profile')" >  پروفايل كاربري آزمايشگاه كاليبراسيون  </p> -->
    <!-- <div style=""> </div> -->
    <div id="routes">
       <!-- supplier routes -->
      
       <router-link
       v-if="showRoute(getRole, '/admin-panel/supplier/profile')"
       :class="{ activeRoute: $route.name == 'supplierProfile' }"
       to="/admin-panel/supplier/profile"
     >
       <span> اطلاعات کاربری <i class="fa fa-user"></i></span
     ></router-link>
     <router-link
       v-if="showRoute(getRole, '/admin-panel/calibrationLab-homePage')"
       :class="{ activeRoute: $route.name == 'calibrationLabHomePage' }"
       to="/admin-panel/calibrationLab-homePage"
     >
       <span> صفحه اصلي</span
     ></router-link>
     <router-link
       v-if="showRoute(getRole, '/admin-panel/calibrationLab/profile')"
       :class="{ activeRoute: $route.name == 'calibrationLabProfile' }"
       to="/admin-panel/calibrationLab/profile"
     >
       <span> اطلاعات کاربری <i class="fa fa-user"></i></span
     ></router-link>
       
     <router-link
       v-if="showRoute(getRole, '/admin-panel/supplier/news')"
       :class="{ activeRoute: $route.name == 'supplierNewsList' }"
       to="/admin-panel/supplier/news"
     >
       <span> مشاهده آگهی <i class="fa fa-blog"></i></span
     ></router-link>
       
     <router-link
       v-if="showRoute(getRole, '/admin-panel/supplier/message')"
       :class="{ activeRoute: $route.name == 'supplierMessage' }"
       to="/admin-panel/supplier/message"
     >
       <span> مشاهده پیام ها <i class="fa fa-comment"></i></span
     ></router-link>
     <router-link
      v-if="showRoute(getRole, '/admin-panel/calibrationLab-Survey')"
      :class="{ activeRoute: $route.name == 'calibrationLab-Survey' }"
      to="/admin-panel/calibrationLab-Survey"
      >
      <!-- <i class="fa fa-angle-down" ></i> -->
      <span>
           نظرسنجي آزمايشگاه كاليبراسيون
        <!-- <i class="fa fa-lab" aria-hidden="true"></i> -->
        <i class="fa fa-flask" aria-hidden="true"></i>
      </span>
      </router-link>
     <router-link
      v-if="showRoute(getRole, '/admin-panel/calibrationLab-list')"
      :class="{ activeRoute: $route.name == 'calibrationLab-list' }"
      to="/admin-panel/calibrationLab-list"
      >
      <!-- <i class="fa fa-angle-down" ></i> -->
      <span>
           ليست آزمايشگاه كاليبراسيون
        <!-- <i class="fa fa-lab" aria-hidden="true"></i> -->
        <i class="fa fa-flask" aria-hidden="true"></i>
      </span>
      </router-link>
      <router-link
      v-if="showRoute(getRole, '/admin-panel/calibrationLab-orders')"
      :class="{ activeRoute: $route.name == 'calibrationLab-orders' }"
      to="/admin-panel/calibrationLab-orders"
      >
      <!-- <i class="fa fa-angle-down" ></i> -->
      <span>
           سفارشات آزمايشگاه كاليبراسيون
        <!-- <i class="fa fa-lab" aria-hidden="true"></i> -->
        <i class="fa fa-cart-plus" aria-hidden="true"></i>
      </span>
      </router-link>
     <router-link
       v-if="showRoute(getRole, '/admin-panel/calibrationLab/calibrationLab-message')"
       :class="{ activeRoute: $route.name == 'calibrationLabMessage' }"
       to="/admin-panel/calibrationLab/calibrationLab-message"
     >
       <span> مشاهده پیام ها <i class="fa fa-comment"></i></span
     ></router-link> 
       <router-link
         v-if="showRoute(getRole, '/admin-panel/supplier/change-password')"
         :class="{ activeRoute: $route.name == 'supplierChangePassword' }"
         to="/admin-panel/supplier/change-password"
       >
         <span>  تغییر رمز <i class="fa fa-eye"></i></span
       ></router-link>
       
       <!-- <router-link
         v-if="showRoute(getRole, '/admin-panel/supplier-message')"
         :class="{ activeRoute: $route.name == 'supplierMessage' }"
         to="/admin-panel/supplier-message"
       >
         <span>پیام ها<i class="fa fa-blog"></i></span
       ></router-link> -->
      <router-link
        v-if="showRoute(getRole, '/admin-panel/about-us')"
        :class="{ activeRoute: $route.name == 'panelAboutUs' }"
        to="/admin-panel/about-us"
      >
        <span>
          درباره ما
          <i class="fa fa-info-circle" aria-hidden="true"></i>
        </span>
      </router-link>

      <router-link
        v-if="showRoute(getRole, '/admin-panel/menus')"
        :class="{ activeRoute: $route.name == 'panelMenu' }"
        to="/admin-panel/menus"
      >
      <i class="fa fa-angle-down" v-b-toggle.collapse-58></i>
        <span>
          منوها
          <i class="fa fa-bars" aria-hidden="true"></i>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/utility-menu')"
        id="collapse-58"
        class="mt-2"
      >
      <router-link
       class="childRoute"
        v-if="showRoute(getRole, '/admin-panel/utility-menu')"
        :class="{ activeRoute: $route.name == 'utilityMenu' }"
        to="/admin-panel/utility-menu"
      >
        <span>
          لینک های کاربردی
          <i class="fa fa-bars" aria-hidden="true"></i>
        </span>
      </router-link>
  </b-collapse>
      <router-link
        v-if="showRoute(getRole, '/admin-panel/orders')"
        :class="{ activeRoute: $route.name == 'panelOrder' }"
        to="/admin-panel/orders"
      >
        <span>
          سفارشات
          <i class="fa fa-bars" aria-hidden="true"></i>
        </span>
      </router-link>
      <router-link
        v-if="showRoute(getRole, '/admin-panel/management')"
        :class="{ activeRoute: $route.name == 'panelManagement' }"
        to="/admin-panel/management"
      >
        <span>
          مدیریت
          <i class="fa fa-users" aria-hidden="true"></i>
        </span>
      </router-link>
      <!-- CalibrationLab admin routes -->
      <router-link
      v-if="showRoute(getRole, '/admin-panel/calibrationLabUsers-list')"
      :class="{ activeRoute: $route.name == 'calibrationLabUsers' }"
      to="/admin-panel/calibrationLabUsers-list"
      >
       <i class="fa fa-angle-down" v-b-toggle.collapse-106 ></i> 
      <span>
            آزمايشگاه كاليبراسيون
        <!-- <i class="fa fa-lab" aria-hidden="true"></i> -->
        <i class="fa fa-flask" aria-hidden="true"></i>
      </span>
      </router-link>
      <b-collapse
      v-if="showRoute(getRole, '/admin-panel/calibrationLab-categories')"
      id="collapse-106"
      class="mt-2"
    >
      <router-link
      v-if="showRoute(getRole, '/admin-panel/calibrationLabList')"
      :class="{ activeRoute: $route.name == 'calibrationLabList' }"
      to="/admin-panel/calibrationLabList"
      >
      <!-- <i class="fa fa-angle-down" ></i> -->
      <span>
           ليست آزمايشگاه كاليبراسيون
        <!-- <i class="fa fa-lab" aria-hidden="true"></i> -->
        <i class="fa fa-flask" aria-hidden="true"></i>
      </span>
      </router-link>
      <router-link
    class="childRoute"
       v-if="showRoute(getRole, '/admin-panel/calibrationLab-messageAdmin')"
       :class="{ activeRoute: $route.name == 'calibrationLabMessageAdmin' }"
       to="/admin-panel/calibrationLab-messageAdmin"
     >
       <span> مشاهده پیام ها <i class="fa fa-comment"></i></span
     ></router-link>
     <router-link
      v-if="showRoute(getRole, '/admin-panel/calibrationLabOrders')"
      :class="{ activeRoute: $route.name == 'calibrationLabOrders' }"
      to="/admin-panel/calibrationLabOrders"
      >
      <!-- <i class="fa fa-angle-down" ></i> -->
      <span>
           سفارشات آزمايشگاه كاليبراسيون
        <!-- <i class="fa fa-lab" aria-hidden="true"></i> -->
        <i class="fa fa-cart-plus" aria-hidden="true"></i>
      </span>
      </router-link>
      <!-- <router-link
      v-if="showRoute(getRole, '/admin-panel/calibrationLabOrders')"
      :class="{ activeRoute: $route.name == 'calibrationLabOrders' }"
      to="/admin-panel/calibrationLabOrders"
      >
      <span>
           سفارشات آزمايشگاه كاليبراسيون
        <i class="fa fa-cart-plus" aria-hidden="true"></i>
      </span>
      </router-link> -->
      
    </b-collapse>
      <!-- supplier admin routes -->
      <router-link
      v-if="showRoute(getRole, '/admin-panel/supplier-list')"
      :class="{ activeRoute: $route.name == 'supplierList' }"
      to="/admin-panel/supplier-list"
      ><i class="fa fa-angle-down" v-b-toggle.collapse-105></i>
      <span>
         تامین کنندگان
        <i class="fa fa-users" aria-hidden="true"></i>
      </span>
    </router-link>
    <b-collapse
      v-if="showRoute(getRole, '/admin-panel/supplier-news-categories')"
      id="collapse-105"
      class="mt-2"
    >
    <router-link
      :class="{ activeRoute: $route.name == 'supplierNews' }"
      class="childRoute"
      to="/admin-panel/supplier-news"
    >
      <span>
        اخبار تامین کنندگان
        <i class="fa fa-blog" aria-hidden="true"></i></span
    ></router-link>
    <router-link
    class="childRoute"
       v-if="showRoute(getRole, '/admin-panel/supplier-message')"
       :class="{ activeRoute: $route.name == 'supplierMessageAdmin' }"
       to="/admin-panel/supplier-message"
     >
       <span> مشاهده پیام ها <i class="fa fa-comment"></i></span
     ></router-link>
    <router-link
      :class="{ activeRoute: $route.name == 'supplierNewsCategories' }"
      class="childRoute"
      to="/admin-panel/supplier-news-categories"
    >
      <span>
        دسته بندی
        <i class="fa fa-align-justify" aria-hidden="true"></i></span
    ></router-link>
    

    </b-collapse>

      <router-link
        v-if="showRoute(getRole, '/admin-panel/reports')"
        :class="{ activeRoute: $route.name == 'panelReport' }"
        to="/admin-panel/reports"
      >
        <span>
          گزارشات
          <i class="fa fa-info-circle" aria-hidden="true"></i>
        </span>
      </router-link>
      <!-- start gallery -->
      <router-link
        v-if="showRoute(getRole, '/admin-panel/galleries')"
        :class="{ activeRoute: $route.name == 'galleries' }"
        to="/admin-panel/galleries"
        ><i class="fa fa-angle-down" v-b-toggle.collapse-60></i>
        <span>
          گالری
          <i class="fa fa-blog" aria-hidden="true"></i>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/gallery-introduction')"
        id="collapse-60"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'galleryIntroduction' }"
          class="childRoute"
          to="/admin-panel/gallery-introduction"
        >
          <span>
            معرفی نامه
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>
        <router-link
          :class="{ activeRoute: $route.name == 'panelgalleryCategories' }"
          class="childRoute"
          to="/admin-panel/gallery-categories"
        >
          <span
            >دسته بندی
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <!-- end gallery -->
      <!--  -->
      <router-link
        v-if="showRoute(getRole, '/admin-panel/weblogs')"
        :class="{ activeRoute: $route.name == 'panelWeblogs' }"
        to="/admin-panel/weblogs"
        ><i class="fa fa-angle-down" v-b-toggle.collapse-1></i>
        <span>
          پست ها
          <i class="fa fa-blog" aria-hidden="true"></i>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/weblog-categories')"
        id="collapse-1"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'panelWeblogCategories' }"
          class="childRoute"
          to="/admin-panel/weblog-categories"
        >
          <span>
            دسته بندی
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>
        <router-link
          to="/admin-panel/weblog-comments"
          :class="{ activeRoute: $route.name == 'panelWeblogComment' }"
          class="childRoute"
        >
          <!--  -->
          <span>
            دیدگاه ها
            <i class="fa fa-comments" aria-hidden="true"></i></span
        ></router-link>
        <router-link
          :class="{ activeRoute: $route.name == 'panelFaqIntroduction' }"
          class="childRoute"
          to="/admin-panel/weblogs-introduction"
        >
          <span>
            تنظیمات معرفی
            <i class="fa fa-newspaper" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
<!-- end of posts -->
<!-- start social -->
<router-link
        v-if="showRoute(getRole, '/admin-panel/social-responsibily')"
        :class="{ activeRoute: $route.name == 'SocialResponsibily' }"
        to="/admin-panel/social-responsibily"
        ><i class="fa fa-angle-down" v-b-toggle.collapse-60></i>
        <span>
          مسئولیت اجتماعی
          <i class="fa fa-blog" aria-hidden="true"></i>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/social-responsibily-introduction')"
        id="collapse-60"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'socialResponsibilyIntroduction' }"
          class="childRoute"
          to="/admin-panel/social-responsibily-introduction"
        >
          <span>
            معرفی نامه
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <!-- end social -->
      <!-- start report -->
      <router-link
        v-if="showRoute(getRole, '/admin-panel/reportage')"
        :class="{ activeRoute: $route.name == 'reportage' }"
        to="/admin-panel/reportage"
        ><i class="fa fa-angle-down" v-b-toggle.collapse-61></i>
        <span>
          گزارشات
          <i class="fa fa-blog" aria-hidden="true"></i>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/reportage-introduction')"
        id="collapse-61"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'reportageIntroduction' }"
          class="childRoute"
          to="/admin-panel/reportage-introduction"
        >
          <span>
            معرفی نامه
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <!-- end report -->
      <!-- start partner -->
       <router-link
        v-if="showRoute(getRole, '/admin-panel/partners-panel')"
        :class="{ activeRoute: $route.name == 'partnersPanel' }"
        to="/admin-panel/partners-panel"
        ><i class="fa fa-angle-down" v-b-toggle.collapse-101></i>
        <span>
          پنل همکاران
          <i class="fa fa-blog" aria-hidden="true"></i>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/partners-introduction')"
        id="collapse-101"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'partnersIntroduction' }"
          class="childRoute"
          to="/admin-panel/partners-introduction"
        >
          <span>
            معرفی نامه
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <!-- end partner -->
      <!-- start mag -->
          <router-link
        v-if="showRoute(getRole, '/admin-panel/magazine')"
        :class="{ activeRoute: $route.name == 'magazine' }"
        to="/admin-panel/magazine"
        ><i class="fa fa-angle-down" v-b-toggle.collapse-62></i>
        <span>
          مجله آفتاب
          <i class="fa fa-blog" aria-hidden="true"></i>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/magazine-introduction')"
        id="collapse-62"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'magazineIntroduction' }"
          class="childRoute"
          to="/admin-panel/magazine-introduction"
        >
          <span>
            معرفی نامه
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <!-- end mag -->
             <router-link
             v-if="getRole!='Supplier' && getRole!='CalibrationLab'  && getRole!='CalibrationLab_managment'"
        :class="{ activeRoute: $route.name == 'uploadFile' }"
        to="/admin-panel/upload-file"
        >
        <span>
          آپلود فایل
          <i class="fa fa-file" aria-hidden="true"></i>
        </span>
      </router-link>
<!-- start faq -->
      <router-link
        v-if="showRoute(getRole, '/admin-panel/faqs')"
        :class="{ activeRoute: $route.name == 'panelFaqs' }"
        to="/admin-panel/faqs"
      >
        <i class="fa fa-angle-down" v-b-toggle.collapse-5></i>
        <span>
          پرسش ها <i class="fa fa-question-circle" aria-hidden="true"></i></span
      ></router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/faq-categories')"
        id="collapse-5"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'panelFaqCategories' }"
          class="childRoute"
          to="/admin-panel/faq-categories"
        >
          <span>
            دسته بندی
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>

        <router-link
          :class="{ activeRoute: $route.name == 'panelFaqIntroduction' }"
          class="childRoute"
          to="/admin-panel/faq-introduction"
        >
          <span>
            تنظیمات معرفی
            <i class="fa fa-newspaper" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <router-link
        v-if="showRoute(getRole, '/admin-panel/contact-us')"
        :class="{ activeRoute: $route.name == 'panelContactUs' }"
        to="/admin-panel/contact-us"
      >
        <i class="fa fa-angle-down" v-b-toggle.collapse-10></i>

        <span>
          تماس با ما
          <i class="fa fa-address-book" aria-hidden="true"></i></span
      ></router-link>
      
  
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/contact-us-introduction')"
        id="collapse-10"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'panelContactUsIntroduction' }"
          class="childRoute"
          to="/admin-panel/contact-us-introduction"
        >
          <span>
            تنظیمات معرفی
            <i class="fa fa-newspaper" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
          <router-link
        v-if="showRoute(getRole, '/admin-panel/InovativeIdea')"
        :class="{ activeRoute: $route.name == 'InovativeIdea' }"
        to="/admin-panel/InovativeIdea"
      >

        <span>
         تحت توسعه
          <i class="fa fa-address-book" aria-hidden="true"></i></span
      ></router-link>
      <router-link
        v-if="showRoute(getRole, '/admin-panel/cooperation')"
        :class="{ activeRoute: $route.name == 'panelCooperation' }"
        to="/admin-panel/cooperation"
      >
        <i class="fa fa-angle-down" v-b-toggle.collapse-11></i>
        <span>
          همکاری با ما <i class="fa fa-user-plus" aria-hidden="true"></i></span
      ></router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/cooperation-introduction')"
        id="collapse-11"
        class="mt-2"
      >
        <router-link
          :class="{
            activeRoute: $route.name == 'panelCooperationIntroduction'
          }"
          class="childRoute"
          to="/admin-panel/cooperation-introduction"
        >
          <span>
            تنظیمات معرفی
            <i class="fa fa-newspaper" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <router-link
        v-if="showRoute(getRole, '/admin-panel/prize')"
        :class="{ activeRoute: $route.name == 'panelPrize' }"
        to="/admin-panel/prize"
      >
        <span>
          جوایز
          <i class="fa fa-award"></i> </span
      ></router-link>
      <router-link
        v-if="showRoute(getRole, '/admin-panel/panelRecipes')"
        :class="{ activeRoute: $route.name == 'panelRecipes' }"
        to="/admin-panel/recipes"
      >
        <i class="fa fa-angle-down" v-b-toggle.collapse-2></i>
        <span>
          آشپزی
          <i class="fa fa-hamburger"></i>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/recipe-categories')"
        id="collapse-2"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'panelRecipeCategories' }"
          class="childRoute"
          to="/admin-panel/recipe-categories"
        >
          <span>
            دسته بندی
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>
        <router-link
          :class="{ activeRoute: $route.name == 'productsIntroduction' }"
          class="childRoute"
          to="/admin-panel/recipes-introduction"
        >
          <span>
            تنظیمات معرفی
            <i class="fa fa-newspaper" aria-hidden="true"></i></span
        ></router-link>
        <router-link
          v-if="showRoute(getRole, '/admin-panel/recipe-comments')"
          to="/admin-panel/recipe-comments"
          :class="{ activeRoute: $route.name == 'panelRecipeComment' }"
          class="childRoute"
        >
          <span>
            دیدگاه ها
            <!--  -->

            <i class="fa fa-comments" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <router-link
        v-if="showRoute(getRole, '/admin-panel/settings')"
        :class="{ activeRoute: $route.name == 'panelSettings' }"
        to="/admin-panel/settings"
      >
        <span> تنظیمات اصلی <i class="fa fa-cog" aria-hidden="true"></i></span
      ></router-link>
      <router-link
        v-if="showRoute(getRole, '/admin-panel/sliders')"
        :class="{ activeRoute: $route.name == 'panelSliders' }"
        to="/admin-panel/sliders"
      >
        <span>
          اسلایدر
          <i class="fa fa-photo-video"></i></span
      ></router-link>
      <router-link
        v-if="showRoute(getRole, '/admin-panel/products')"
        :class="{ activeRoute: $route.name == 'panelProducts' }"
        to="/admin-panel/products"
        ><i class="fa fa-angle-down" v-b-toggle.collapse-3></i>

        <span>
          محصولات
          <svg
            id="_056-water-bottle"
            data-name="056-water-bottle"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="20"
            viewBox="0 0 246.551 512"
          >
            <path
              id="Path_163"
              data-name="Path 163"
              d="M132.725,232.427l21.439,32.158-21.439,32.158V512h246.55V296.743l-21.439-32.158,21.439-32.158V150.1H132.725Z"
              transform="translate(-132.724)"
            />
            <path
              id="Path_164"
              data-name="Path 164"
              d="M379.275,103.747a43.7,43.7,0,0,0-43.7-43.7H301.024V0H210.975V60.048H176.423a43.7,43.7,0,0,0-43.7,43.7V120.1h246.55V103.747Z"
              transform="translate(-132.724)"
            />
          </svg>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/products-introduction')"
        id="collapse-3"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'productsIntroduction' }"
          class="childRoute"
          to="/admin-panel/products-introduction"
        >
          <span>
            تنظیمات معرفی
            <i class="fa fa-newspaper" aria-hidden="true"></i></span
        ></router-link>
        <router-link
          :class="{ activeRoute: $route.name == 'panelProductCategories' }"
          class="childRoute"
          to="/admin-panel/product-categories"
        >
          <span
            >دسته بندی
            <i class="fa fa-align-justify" aria-hidden="true"></i></span
        ></router-link>

        <router-link
          :class="{ activeRoute: $route.name == 'panelProductBrand' }"
          class="childRoute"
          to="/admin-panel/product-brand"
        >
          <span> برندها <i class="fa fa-copyright" aria-hidden="true"></i></span
        ></router-link>

        <router-link
          to="/admin-panel/product-comments"
          :class="{ activeRoute: $route.name == 'panelProductComment' }"
          class="childRoute"
        >
          <span>
            دیدگاه ها
            <!--  -->

            <i class="fa fa-comments" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <!--  -->

      <router-link
        v-if="showRoute(getRole, '/admin-panel/catalogues')"
        :class="{ activeRoute: $route.name == 'panelCatalogue' }"
        to="/admin-panel/catalogues"
        ><i class="fa fa-angle-down" v-b-toggle.collapse-31></i>

        <span>
          کاتالوگ ها
          <i class="fa fa-file"></i>
        </span>
      </router-link>
      <b-collapse
        v-if="showRoute(getRole, '/admin-panel/catalogue-introduction')"
        id="collapse-31"
        class="mt-2"
      >
        <router-link
          :class="{ activeRoute: $route.name == 'panelCatalogueIntroduction' }"
          class="childRoute"
          to="/admin-panel/catalogue-introduction"
        >
          <span>
            تنظیمات معرفی
            <i class="fa fa-newspaper" aria-hidden="true"></i></span
        ></router-link>
      </b-collapse>
      <!--  -->
      <router-link
        v-if="showRoute(getRole, '/admin-panel/users')"
        :class="{ activeRoute: $route.name == 'panelUsers' }"
        to="/admin-panel/users"
      >
        <span> کاربران <i class="fa fa-users" aria-hidden="true"></i></span
      ></router-link>
    
      <router-link
        v-if="showRoute(getRole, '/admin-panel/user-question')"
        :class="{ activeRoute: $route.name == 'panelUserRole' }"
        to="/admin-panel/user-question"
      >
        <span> سوالات کاربران <i class="fa fa-user-edit"></i></span
      ></router-link>
      <a  v-if="getRole!='Supplier' && getRole!='CalibrationLab'  && getRole!='CalibrationLab_managment'" style="cursor: pointer" target="_blank" href="https://analytics.google.com/analytics/web/#/p411785530/reports/reportinghub?params=_u..nav%3Dmaui">
        <span> بازیدکنندگان سایت 
          <i class="fas fa-signal"></i>
        </span>
      </a>
      <a v-if="getRole=='CalibrationLab_managment'" title="فايل راهنما" target="_blank" href="https://test.mmc.ir/uploadFileFile/26f31124-e54c-4272-b608-60fc7e63ff46.pdf">
        <span> فايل راهنما مدير سيستم 
            <svg height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	         viewBox="0 0 431.855 431.855" xml:space="preserve">
            <g>
          	<path style="fill:#894a00;" d="M215.936,0C96.722,0,0.008,96.592,0.008,215.814c0,119.336,96.714,216.041,215.927,216.041
		c119.279,0,215.911-96.706,215.911-216.041C431.847,96.592,335.214,0,215.936,0z M231.323,335.962
		c-5.015,4.463-10.827,6.706-17.411,6.706c-6.812,0-12.754-2.203-17.826-6.617c-5.08-4.406-7.625-10.575-7.625-18.501
		c0-7.031,2.463-12.949,7.373-17.745c4.91-4.796,10.933-7.194,18.078-7.194c7.031,0,12.949,2.398,17.753,7.194
		c4.796,4.796,7.202,10.713,7.202,17.745C238.858,325.362,236.346,331.5,231.323,335.962z M293.856,180.934
		c-3.853,7.145-8.429,13.306-13.737,18.501c-5.292,5.194-14.81,13.924-28.548,26.198c-3.788,3.463-6.836,6.503-9.12,9.12
		c-2.284,2.626-3.991,5.023-5.105,7.202c-1.122,2.178-1.983,4.357-2.593,6.535c-0.61,2.17-1.528,5.999-2.772,11.469
		c-2.113,11.608-8.754,17.411-19.915,17.411c-5.804,0-10.681-1.894-14.656-5.69c-3.959-3.796-5.934-9.429-5.934-16.907
		c0-9.372,1.455-17.493,4.357-24.361c2.886-6.869,6.747-12.892,11.543-18.086c4.804-5.194,11.274-11.356,19.427-18.501
		c7.145-6.251,12.307-10.965,15.485-14.144c3.186-3.186,5.861-6.73,8.031-10.632c2.187-3.91,3.26-8.145,3.26-12.721
		c0-8.933-3.308-16.46-9.957-22.597c-6.641-6.137-15.209-9.21-25.703-9.21c-12.282,0-21.321,3.097-27.125,9.291
		c-5.804,6.194-10.705,15.314-14.729,27.369c-3.804,12.616-11.006,18.923-21.598,18.923c-6.251,0-11.526-2.203-15.826-6.609
		c-4.292-4.406-6.438-9.177-6.438-14.314c0-10.6,3.406-21.346,10.21-32.23c6.812-10.884,16.745-19.899,29.807-27.036
		c13.054-7.145,28.296-10.722,45.699-10.722c16.184,0,30.466,2.991,42.854,8.966c12.388,5.966,21.963,14.087,28.718,24.361
		        c6.747,10.266,10.128,21.427,10.128,33.482C299.635,165.473,297.709,173.789,293.856,180.934z"/>
            </g>
          </svg> 
        </span>
   </a> 
      <a style="cursor: pointer" @click="signOut()">
        <span>خروج <i class="fa fa-sign-out-alt"></i></span>
      </a>
    </div>
  </div>
</template>
<script>
import { BCollapse, VBToggle } from "bootstrap-vue";
import RoleMixin from "@/libraries/adminRole";
export default {
  directives: {
    "b-toggle": VBToggle
  },
  mixins: [RoleMixin],
  components: {
    BCollapse
  },
  computed: {
    getRole() {
      if (this.$store.getters.getAdminPanelRole == null) {
        return "";
      } else {
        return this.$store.getters.getAdminPanelRole;
      }
    }
  },
  mounted() {},
  methods: {
    signOut() {
      this.$cookie.delete("Authorization");
      this.$axios.defaults.headers.common["authorization"] = "Bearer ";
      this.$router.push("/login");
    }
  }
};
</script>
<style scoped>
div#mainNavbarAdmin a.childRoute {
  padding: 10px 60px 0 0;
}
div#mainNavbarAdmin a {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  font-family: "yekan-bold";
  width: 100%;
  text-align: right;
  padding: 10px;
}
div#mainNavbarAdmin a span i,
div#mainNavbarAdmin a span svg {
  margin: 0 10px;
}
div#mainNavbarAdmin {
  width: 20%;
  height: 100vh;
  background: #c0c0c06b;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.activeRoute {
  border-left: 5px solid var(--color-theme);
  background: linear-gradient(45deg, #f7941ebf, transparent);
}
a:hover {
  border-left: 5px solid var(--color-theme);
  background: linear-gradient(45deg, #f7941ebf, transparent);
}
.fa.fa-angle-down {
  float: left;
  position: relative;
  padding: 15px;
  bottom: 10px;
}
#routes a i {
  color: #894a00;
}
#routes a svg path {
  fill: #894a00;
}
.collapse {
  margin-bottom: 0.5rem !important ;
}
#gotoHome:hover {
  border-left: unset;
  background: transparent;
}
</style>
